export namespace HybridProPanelHelper {
  export enum SecondaryHeatGeneratorModes {
    MonovalentOperation = 'monovalentOperation',
    BivalentParallel = 'bivalentParallel',
  }

  export enum SecondaryHeatGeneratorOperatingModesActive {
    Fixed = 'fixed',
    Economical = 'economical',
    Ecological = 'ecological',
    Off = 'off',
  }
}
